import React from 'react';
import PropTypes from 'prop-types';
import {defineMessages, FormattedMessage, injectIntl} from 'react-intl';
import {ButtonGroup, Button} from 'react-bootstrap';
import {Form} from 'formsy-react-components';
import bootbox from "bootbox";
import {compoundApplicationName} from '../fw/GridList.react';
import ChannelIcon from '../channel-defs/ChannelIcon.react';
import ScenarioChannelConnect from './ScenarioChannelConnect.react';

const messages = defineMessages({
	submit: {id: 'organisationCompanySearch.submit', 'defaultMessage': 'Save'},
	cancel: {id: 'cancel', 'defaultMessage': 'Cancel'},
	confirmDisableConfidential: {id: 'confirmDisableConfidential', 'defaultMessage': 'Confidential mode will be disabled.'}
});

class ChannelChooser extends React.Component {
	static propTypes = {
		channelGroup: PropTypes.exact({
			channels: PropTypes.arrayOf(PropTypes.object).isRequired,
			channelDef: PropTypes.object.isRequired
		}),
		connectCallback: PropTypes.func,
		intl: PropTypes.object.isRequired,
		nextStep: PropTypes.func.isRequired,
		onChannelSelect: PropTypes.func.isRequired,
		scenario: PropTypes.object,
	};

	static sortByName(channelA, channelB) {
		let aName = channelA.name ? channelA.name : channelA.channelDef.name;
		let bName = channelB.name ? channelB.name : channelB.channelDef.name;

		return aName.localeCompare(bName);
	}

	constructor(props) {
		super(props);

		this.state = {
			chooser: true
		};
	}

	toggleChooser(showChooser: boolean = false) {
		this.setState({
			chooser: showChooser
		});
	}

	showConfirmDialog(channel) {
		return new Promise(resolve => {
			bootbox.confirm({
				message: this.props.intl.formatMessage(messages.confirmDisableConfidential),
				size: 'small',
				buttons: {
					cancel: {
						label: this.props.intl.formatMessage(messages.cancel),
						className: "btn-default",
					},
					confirm: {
						label: this.props.intl.formatMessage(messages.submit),
						className: "btn-danger",
					},
				},
				callback: (result) => {
					if (result) {
							this.props.onChannelSelect(channel);
							this.props.nextStep();

							return resolve();
					}

					resolve();
				}
			});
		});
	}

	async channelChooseClick(channel) {
		if (channel.hasError === true) {
			return this.showConfirmDialog(channel);
		}

		this.props.onChannelSelect(channel);
		this.props.nextStep();
		return Promise.resolve();
	}

	getButtons() {
		let {channelGroup} = this.props;

		return this.props.channelGroup.channels
			.sort(ChannelChooser.sortByName)
			.map((channel, idx) => {
				return (
					<Button className={channel.isItemActive ? 'active' : ''} key={idx} onClick={() => {
						return this.channelChooseClick(channel);
					}}>
						<ChannelIcon channelDef={channelGroup.channelDef} size={32}/>&nbsp;
						{compoundApplicationName(channelGroup.channelDef.name, channel.name)}
					</Button>
				);
			}
		);
	}

	render() {
		let {channelGroup} = this.props;
		let isOneItem = this.props.channelGroup.channels.length === 1;

		let channel;
		if (isOneItem) {
			channel = this.props.channelGroup.channels[0];
		}

		if (this.state.chooser) {
			return (
				<Form onSubmit={() => {this.props.nextStep();}}>
					<div key="channelsToSelect">
						<div>
							{isOneItem
								? (
									<div>
										<FormattedMessage defaultMessage="Use already connected application:" id="scenarioApply.alreadyConnectedChannel"/>

										<div className="singleChannelName">
											<ChannelIcon channelDef={channelGroup.channelDef} size={32}/>&nbsp;
											{compoundApplicationName(channelGroup.channelDef.name, channel.name)}
										</div>

										<Button bsStyle="primary" onClick={() => {
											return this.channelChooseClick(channel);
										}}>
											<FormattedMessage defaultMessage="Next >" id="common.next" />
										</Button>
									</div>
								)
								: (<div>
									<FormattedMessage defaultMessage="Choose for which {name} should the scenario apply:" id="scenarioApply.channelsToSelect" values={{name: channelGroup.channelDef.name}}/><br />

									<ButtonGroup className="channelsToSelectButtonGroup" vertical>
										{this.getButtons()}
									</ButtonGroup>
								</div>)
							}
							<br />
							<FormattedMessage defaultMessage="Or {link}" id="scenarioApply.or" values={{link: (
								<a href="#" onClick={() => {this.toggleChooser(false);}}>
									<FormattedMessage defaultMessage="connect another {appName}" id="scenarioApply.connectAnother" values={{appName: channelGroup.channelDef.name}}/><br />
								</a>
							)}}/>
						</div>
					</div>
				</Form>
			);
		}

		return (<ScenarioChannelConnect
			cancel={() => {this.toggleChooser(true);}}
			channelDef={channelGroup.channelDef}
			connectCallback={this.props.connectCallback}
			scenario={this.props.scenario}
		/>);
	}
}

export default injectIntl(ChannelChooser);
